/**
 * /audit — platform audit route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  auditListSearchSchema,
  type AuditListSearch,
} from "@/features/audit/schemas";
import { fetchPlatformAudit } from "@/features/audit/queries";
import { queryKeys } from "@/lib/query-keys";
import { PlatformAuditPage } from "@/features/audit/pages/platform-audit-page";

export const Route = createFileRoute("/_authed/audit/")({
  validateSearch: (raw: Record<string, unknown>): AuditListSearch =>
    auditListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.audit.platformEvents(deps.search),
      queryFn: () => fetchPlatformAudit(deps.search),
    }),
  component: PlatformAuditPage,
});
